export function getKeyByValue(obj, searchValue) {
    for (const key in obj) {
        if (obj[key] === searchValue) {
            return key;
        }
    }
    return null;
}